/** One category on the home screen. Tapping it opens that category's menu. */

import { CATEGORY_RULES } from "../features/food/categories";
import type { FoodCategory } from "../features/food/types";
import { CATEGORY_ICONS, Icon } from "./Icon";

import "./CategoryTile.css";

interface CategoryTileProps {
  category: FoodCategory;
  onOpen: (category: FoodCategory) => void;
}

export function CategoryTile({ category, onOpen }: CategoryTileProps) {
  return (
    // data-category drives the icon colour from theme.css, so the component
    // still defines no colour of its own.
    <button
      className="tile"
      type="button"
      data-category={category}
      onClick={() => onOpen(category)}
    >
      <Icon name={CATEGORY_ICONS[category]} className="tile__icon" />
      <span className="tile__label">{CATEGORY_RULES[category].label}</span>
    </button>
  );
}
